import { render, staticRenderFns } from "./AddressGeo.vue?vue&type=template&id=649a233c&"
import script from "./AddressGeo.vue?vue&type=script&lang=ts&"
export * from "./AddressGeo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports